import { RootState } from '../../store';

export const getReferralUserProgressesListSelector = (state: RootState) =>
  state.referralUserProgressSliceReducer.userProgressesList;

export const getReferralUserProgressesPageSelector = (state: RootState) =>
  state.referralUserProgressSliceReducer.userProgressesPage;

export const getReferralUserProgressesTotalCountSelector = (state: RootState) =>
  state.referralUserProgressSliceReducer.userProgressesTotalCount;

export const refreshUserProgressesTableSelector = (state: RootState) =>
  state.referralUserProgressSliceReducer.refreshReferralTable;
